import { Component, Input } from '@angular/core';
import { Merchant } from '../../../models/merchant/merchant';
import { MerchantProcessor } from '../../../models/merchant/merchantProcessor';
import { GatewayName, ProcessorName } from '../../../core/constants';

@Component({
  selector: 'app-merchant-support-info',
  templateUrl: './merchant-support-info.component.html',
  standalone: false,
})
export class MerchantSupportInfoComponent {
  @Input() location: Merchant | undefined;

  public processingInfo: MerchantProcessor | undefined;
  public brand: string = '';

  gatewayName = GatewayName;
  processorName = ProcessorName;

  gatewaySupport = {
    name: '',
    url: '',
    phone: '',
    email: '',
  };

  processorSupport = {
    name: '',
    supportPhone: '',
    pciPhone: '',
  };

  constructor() {}

  ngOnChanges() {
    this.ngAfterViewInit();
  }

  ngAfterViewInit() {
    if (this.location) {
      if (this.location.brandName) {
        this.brand = this.location?.brandName;
      }

      if (this.location.processors && this.location.processors.length > 0) {
        // if (this.location.processors[0].gateway == this.gatewayName.AuthNet) {
        //   this.gatewaySupport.name = "Authorize.net";
        //   this.gatewaySupport.url = "https://login.authorize.net";
        //   this.gatewaySupport.phone = "1-877-447-3938";
        // }

        switch (this.location.processors[0].processor) {
          case this.processorName.Elavon:
            this.processorSupport.name = 'Elavon';
            this.processorSupport.supportPhone = '1-800-725-1243';
            break;
          case this.processorName.Worldpay:
            this.processorSupport.name = 'Worldpay';
            this.processorSupport.supportPhone = '1-888-208-7231';
            this.processorSupport.pciPhone = '1-833-534-8422';
            break;
          case this.processorName.Fiserv:
            this.processorSupport.name = 'Fiserv';
            this.processorSupport.supportPhone = '1-888-263-1938';
            break;
          case this.processorName.TSYS:
            this.processorSupport.name = 'TSYS';
            this.processorSupport.supportPhone = '';
            break;
          case this.processorName.NMI:
            this.processorSupport.name = 'NMI';
            this.processorSupport.supportPhone = '';
            break;
          case this.processorName.Converge:
            this.processorSupport.name = 'Converge';
            this.processorSupport.supportPhone = '';
            break;
          case this.processorName.ProPay:
            this.processorSupport.name = 'ProPay';
            this.processorSupport.supportPhone = '';
            break;
        }
      }
    }
  }
}
